import React, { useState, useEffect } from 'react';
import axios from 'axios';

import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import Box from '@mui/material/Box';
import Fab from '@mui/material/Fab';
import RemoveIcon from '@mui/icons-material/Remove';
import DeleteIcon from '@mui/icons-material/Delete';
import MinusIcon from '@mui/icons-material/Remove';
import AddIcon from '@mui/icons-material/Add';
import TextField from '@mui/material/TextField';
import CircularProgress from '@mui/material/CircularProgress';
import DoneGif from '../../images/HomeImages/donejif.gif';

const AddCartButton = ({ ShowDetails, product, addToCart, CartCount, CartTotalPrcice
  , SelectedType, ItemCount, setItemCount, CostAddress,
  setCostAddress, CostPhone, setCostPhone, Note, setNote, AddCartButtonStatus,
  SendVerfication, CheckVerfication, Otp, setOtp,
  timeLeft, SubsecriptionType, SaveLoading,
  setItemNote, CartTotalDiscount, DeliveryTransPrice, handleInputChange, ThemeColor, ShowAddress, PromoAddress, ShowAddressBar,ServicPrice


}) => {

  function Increment() {
    setItemCount(ItemCount + 1)
  }
  function Dcrement() {
    if (ItemCount != 1) {
      setItemCount(ItemCount - 1)
    }

  }


  function OtpChange(e, index) {

    let input = e.target.value;

    // Convert Arabic numbers (٠١٢٣٤٥٦٧٨٩) to English (0123456789)
    const convertedValue = input.replace(
      /[\u0660-\u0669]/g,  // Arabic-Indic digits
      (d) => d.charCodeAt(0) - 0x0660
    ).replace(
      /[\u06F0-\u06F9]/g,  // Persian digits
      (d) => d.charCodeAt(0) - 0x06F0
    );

    // Allow only numbers (prevent letters or symbols)
    if (/^\d*$/.test(convertedValue)) {
      if (isNaN(convertedValue)) return false;
      setOtp([...Otp.map((data, indx) => (indx === index ? convertedValue : data))])

      if (convertedValue && e.target.nextSibling) {
        e.target.nextSibling.focus()
      }
    }




  }

  const handlePaste = (e) => {
    const pasteData = e.clipboardData.getData('text').slice(0, 3); // Get up to 3 characters from the clipboard
    const newOtp = pasteData.split('').map((char, index) => (isNaN(char) ? '' : char));

    // Fill the remaining OTP array with the existing values or empty strings
    while (newOtp.length < 3) {
      newOtp.push('');
    }

    setOtp(newOtp);
  };

  const convertArabicToEnglish = (value) => {
    return value.replace(/[٠-٩]/g, (d) => '٠١٢٣٤٥٦٧٨٩'.indexOf(d));
  };

  return (

    <Box sx={{ m: 1 }}>

      {ShowAddressBar == false && (
        <div >

          {SelectedType == 'Details' && (

            <div>
              <Box sx={{
                color: 'black', paddingTop: 0.5, borderRadius: '15px', bottom: 60, width: 350, height: 50, position: 'fixed', left: '50%',
                transform: 'translateX(-50%)'
              }} >
                <button style={{ border: 'none', backgroundColor: 'none', background: 'none' }} onClick={(e) => (Dcrement())} ><MinusIcon style={{ color: `#${ThemeColor}` }} /></button><label style={{ color: 'black', fontSize: '31px', fontFamily: 'basheer', margin: '25px' }}>{ItemCount}</label> <button style={{ border: 'none', backgroundColor: 'none', background: 'none' }} onClick={(e) => (Increment())} ><AddIcon style={{ color: `#20A17F` }} /></button>

              </Box>

              <Fab
                variant="extended"
                color="primary"
                onClick={(e) => (addToCart(product))}
                aria-label="add"
                sx={{
                  borderRadius: '12px',
                  width: 350,
                  position: 'fixed',
                  bottom: 16,
                  left: '50%',
                  transform: 'translateX(-50%)'
                  ,
                  fontFamily: 'basheer',
                  fontSize: '16px',
                  backgroundColor: `#${ThemeColor}`,
                  '&:hover': {
                    backgroundColor: `#${ThemeColor}`, // optional hover effect
                  },
                }}
              >
                اضف الى السلة




              </Fab>
            </div>
          )}
          {(SelectedType == 'Item' || SelectedType == 'Group' || SelectedType == 'SearchPanel') && (

            <div style={{
              backgroundColor: 'white', width: '100%', height: '9vh',
              position: 'fixed',
              bottom: 1,
              left: '0%',
              fontFamily: 'basheer',
              fontSize: '16px'
            }}>

              <Fab
                variant="extended"

                onClick={(e) => (ShowDetails('Cart'))}
                aria-label="add"
                sx={{
                  borderRadius: '12px',
                  width: 350,
                  position: 'fixed',
                  bottom: 16,
                  left: '50%',
                  color: 'white',
                  transform: 'translateX(-50%)',
                  backgroundColor: `#${ThemeColor}`,
                  fontFamily: 'basheer',
                  fontSize: '16px',
                  '&:hover': {
                    backgroundColor: `#${ThemeColor}`, // optional hover effect
                  },
                }}
              >
                عرض السلة
                <Box
                  sx={{
                    position: 'absolute',
                    top: 10,
                    right: 20,
                    backgroundColor: 'rgba(255, 255, 255, 0.2)',

                    color: 'white',
                    borderRadius: '4px',
                    width: 30,
                    height: 30,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '16px',
                    fontFamily: 'basheer'

                  }}
                >
                  {CartCount}
                </Box>
                <Box
                  sx={{
                    position: 'absolute',
                    top: 12,
                    left: 1,

                    color: 'white',
                    borderRadius: '10%',
                    width: 100,
                    height: 24,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: 12,

                  }}
                >
                  {(CartTotalPrcice - CartTotalDiscount + DeliveryTransPrice+ServicPrice).toLocaleString()} د.ع
                </Box>
              </Fab>
            </div>
          )}

          {(SelectedType == 'Cart') && (

            <Fab
              variant="extended"
              color="primary"

              onClick={(e) => {
                if (SubsecriptionType !== 'EMenu') {
                  ShowDetails('Continue');
                }
              }}
              aria-label="add"
              sx={{
                borderRadius: '12px',
                width: 350,
                position: 'fixed',
                bottom: 16,
                left: '50%',
                transform: 'translateX(-50%)',
                color: 'white',
                backgroundColor: `#${ThemeColor}`,
                fontFamily: 'basheer',
                fontSize: '16px',
                '&:hover': {
                  backgroundColor: `#${ThemeColor}`, // optional hover effect
                },
              }}
            >


              {SubsecriptionType !== 'EMenu' ? 'متابعة الطلب' : 'المجموع'}
              <Box
                sx={{
                  position: 'absolute',

                  top: 10,
                  right: 20,
                  backgroundColor: 'rgba(255, 255, 255, 0.2)',

                  color: 'white',
                  borderRadius: '4px',
                  width: 30,
                  height: 30,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '16px',
                  fontFamily: 'basheer'

                }}
              >
                {CartCount}
              </Box>



              <Box
                sx={{
                  position: 'absolute',
                  top: 12,
                  left: 1,

                  color: 'white',
                  borderRadius: '10%',
                  width: 100,
                  height: 24,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: 12,
                }}
              >
                {(CartTotalPrcice - CartTotalDiscount + DeliveryTransPrice+ServicPrice).toLocaleString()} د.ع
              </Box>
            </Fab>
          )}


          {SelectedType == 'Continue' && (



            <div>

              {AddCartButtonStatus == 'PhoneInfo' && (
                <Box sx={{
                  backgroundColor: 'rgba(0, 0, 0, 0.5)', color: 'white', paddingTop: 0.5, paddingBottom: 0.5, borderRadius: '25px', bottom: 70, width: 350, height: SubsecriptionType === 'ECart' ? '300px' : '230px', position: 'fixed', left: '50%',
                  transform: 'translateX(-50%)'
                }} >


                  {SubsecriptionType == 'ECart' && (
                    <TextField className='col' style={{ minWidth: '90%', backgroundColor: 'white', borderRadius: '10px', margin: '10px', fontFamily: 'basheer', }} placeholder='هاتف الواتساب' type="tel" value={CostPhone} onChange={handleInputChange} required inputProps={{
                      style: {

                        textAlign: 'right',
                        fontFamily: 'basheer',
                      }
                    }} />

                  )}


                  {ShowAddress == 0 && (


                    <TextField className='col' style={{ minWidth: '90%', backgroundColor:SubsecriptionType != 'ECart'? 'white' : 'lightgrey', borderRadius: '10px', margin: '10px', fontFamily: 'basheer' }} inputProps={{
                      style: {

                        fontFamily: 'basheer',

                      },

                    }} placeholder='العنوان' type='string' r value={CostAddress} required onChange={
                      SubsecriptionType !== 'ECart'
                        ? (e) => setCostAddress(e.target.value)
                        : undefined
                    } />



                  )}
                  {ShowAddress == 1 && (
                    <TextField className='col' style={{ minWidth: '90%', backgroundColor: 'lightgrey', borderRadius: '10px', margin: '10px', fontFamily: 'basheer' }} inputProps={{
                      style: {

                        fontFamily: 'basheer',

                      },

                    }} placeholder='العنوان' type='string' value={PromoAddress} required />

                  )}

                  <TextField multiline rows={4} className='col' style={{ minWidth: '90%', backgroundColor: 'white', borderRadius: '10px', margin: '10px', fontFamily: 'basheer' }} inputProps={{
                    style: {

                      fontFamily: 'basheer',

                    },
                  }}  placeholder={SubsecriptionType !== 'ECart' ? 'الملاحظات' : 'اكتب هنا اقرب نقطة دالة'} type='string' value={Note} onChange={(e) => (setNote(e.target.value))} />


                </Box>

              )}
              {AddCartButtonStatus == 'WaitingCode' && (
                <Box sx={{
                  backgroundColor: 'rgba(0, 0, 0, 0.6)', color: 'white', paddingTop: 0.5, paddingBottom: 0.5, borderRadius: '25px', bottom: 70, width: 350, height: '150px', position: 'fixed', left: '50%',
                  transform: 'translateX(-50%)'
                }} >


                  <div style={{ direction: 'ltr', width: '70%', margin: '20px auto', display: 'flex', gap: '10px' }}>
                    {
                      Otp.map((data, i) => {
                        return <input style={{
                          width: '50px', padding: '10px', outline: 'none', textAlign: 'center', borderRadius: '10px'

                        }} type='tel'

                          value={data}
                          maxLength={1}
                          onChange={(e) => OtpChange(e, i)}
                          onPaste={i === 0 ? handlePaste : null} // Attach handlePaste only to the first input

                        />
                      })


                    }

                  </div>
                  <div style={{ textAlign: 'center', marginTop: '20px', marginBottom: '20px' }}>
                    Time left: {timeLeft} seconds
                  </div>


                </Box>
              )}

              {SaveLoading ? (
                <Box sx={{
                  width: 350,
                  position: 'fixed',
                  bottom: 16,
                  left: '50%',
                  transform: 'translateX(-50%)',
                }}>
                  <CircularProgress />
                </Box>
              ) : (
                <Fab
                  variant="extended"



                  onClick={(e) => (AddCartButtonStatus === 'PhoneInfo' ? SendVerfication() : CheckVerfication())}
                  aria-label="add"
                  sx={{
                    borderRadius: '12px',
                    width: 350,
                    position: 'fixed',
                    bottom: 16,
                    color: 'white',
                    left: '50%',
                    transform: 'translateX(-50%)',
                    backgroundColor: `#${ThemeColor}`,
                    fontFamily: 'basheer',
                    fontSize: '16px',
                    '&:hover': {
                      backgroundColor: `#${ThemeColor}`, // optional hover effect
                    },
                  }}
                >
                  ارسال
                  <Box sx={{
                    position: 'absolute',
                    top: 10,
                    right: 20,
                    backgroundColor: 'rgba(255, 255, 255, 0.2)',

                    color: 'white',
                    borderRadius: '4px',
                    width: 30,
                    height: 30,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '16px',
                    fontFamily: 'basheer'

                  }}
                  >
                    {CartCount}
                  </Box>
                  <Box
                    sx={{
                      position: 'absolute',
                      top: 12,
                      left: 1,

                      color: 'white',
                      borderRadius: '10%',
                      width: 100,
                      height: 24,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontSize: 12,
                    }}
                  >
                    {(CartTotalPrcice - CartTotalDiscount + DeliveryTransPrice+ServicPrice).toLocaleString()} د.ع
                  </Box>
                </Fab>
              )}





            </div>




          )}


          {SelectedType == 'Done' && (



            <div>

              <Fab
                variant="extended"




                aria-label="add"
                sx={{
                  padding: '10px',
                  width: '200px',
                  height: '200px',
                  minHeight: 'auto',
                  borderRadius: '202px',
                  position: 'fixed',
                  bottom: 150,
                  left: '50%',
                  transform: 'translateX(-50%)',
                  backgroundColor: `#${ThemeColor}`,
                  color: 'white',
                  '&:hover': {
                    backgroundColor: `#${ThemeColor}`,
                  },
                }}
              >
                <img
                  src={DoneGif}
                  alt="loading"
                  style={{ width: '200px', height: '200px' }}
                />

              </Fab>
              <Fab
                variant="extended"




                aria-label="add"
                sx={{
                  color: 'white',
                  width: 350,
                  position: 'fixed',
                  bottom: 75,
                  left: '50%',
                  transform: 'translateX(-50%)',
                  backgroundColor: `#${ThemeColor}`,
                  fontFamily: 'basheer',
                  fontSize: '16px',
                  '&:hover': {
                    backgroundColor: `#${ThemeColor}`, // optional hover effect
                  },
                }}
              >
                تم ارسال الطلب بنجاح

              </Fab>





              <Fab
                variant="extended"



                onClick={(e) => (ShowDetails('Done'))}
                aria-label="add"
                sx={{
                  color: 'white',
                  width: 350,
                  position: 'fixed',
                  bottom: 16,
                  left: '50%',
                  transform: 'translateX(-50%)',
                  backgroundColor: `#${ThemeColor}`,
                  fontFamily: 'basheer',
                  fontSize: '16px',
                  '&:hover': {
                    backgroundColor: `#${ThemeColor}`, // optional hover effect
                  },
                }}
              >
                طلب جديد

              </Fab>






            </div>




          )}

        </div>
      )}
    </Box>
  )
}


export default AddCartButton